import { render, staticRenderFns } from "./LqsCard.vue?vue&type=template&id=01dc0aa8&scoped=true"
import script from "./LqsCard.vue?vue&type=script&lang=js"
export * from "./LqsCard.vue?vue&type=script&lang=js"
import style0 from "./LqsCard.vue?vue&type=style&index=0&id=01dc0aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc0aa8",
  null
  
)

export default component.exports